<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="轮播图" name="Banner_homepage">
        <Homepage/>
      </el-tab-pane>
      <el-tab-pane label="子栏目" name="Banner_subject">
        <Subject/>
      </el-tab-pane>
    </el-tabs>
    <router-view></router-view>
  </div>
</template>
<script>
import Homepage from './components/homepage';
import Subject from './components/subject';
export default {
  data() {
    return {
      activeName: 'Banner_homepage',
      id:''
    };
  },
  components: {
    Homepage, Subject
  },
  created() {

  },
  mounted() {
    this.id = this.$route.query.id;
  },
  methods: {
    handleClick(tab, event) {

    }
  },

};
</script>



// WEBPACK FOOTER //
// src/pages/system/child_banner_subject/child_banner_subject.vue